// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__74dyb","col":"Table_col__YADbg","fulfillmentStatus":"Table_fulfillmentStatus__6V7hB","emailCol":"Table_emailCol__2_9qW"};